import React from 'react';
import ToastMessageRoot, {
  ToastConfig,
  ToastConfigParams,
} from 'react-native-toast-message';

import { Toast, IToastProps } from './Toast';
import { ToastTypeEnum } from '../../services/ToastService';

type ParamsType = ToastConfigParams<
  Omit<IToastProps, 'type' | 'onHide'>
>;

const toastConfig: ToastConfig = {
  [ToastTypeEnum.Success]: (params: ParamsType) => (
    <Toast
      type={ToastTypeEnum.Success}
      onHide={() => params.hide()}
      {...params.props}
    />
  ),

  [ToastTypeEnum.Error]: (params: ParamsType) => (
    <Toast
      type={ToastTypeEnum.Error}
      onHide={() => params.hide()}
      {...params.props}
    />
  ),

  [ToastTypeEnum.Warning]: (params: ParamsType) => (
    <Toast
      type={ToastTypeEnum.Warning}
      onHide={() => params.hide()}
      {...params.props}
    />
  ),
  [ToastTypeEnum.Info]: (params: ParamsType) => (
    <Toast
      type={ToastTypeEnum.Info}
      onHide={() => params.hide()}
      {...params.props}
    />
  ),
};

export function ToastRoot() {
  return <ToastMessageRoot config={toastConfig} />;
}
